import AbstractRestTask from './abstract-rest-task';
export default class AbstractPutTask extends AbstractRestTask {
    /**
     * Returns the request method
     */
    get method() {
        return 'PUT';
    }
    /**
     * Return the http code that signals a successfull call
     */
    get successCode() {
        return 200;
    }
}
//# sourceMappingURL=abstract-put-task.js.map